import { Directive, Input } from '@angular/core';
import { NglFormElement } from './element';
var NglFormElementRequired = (function () {
    function NglFormElementRequired(nglFormElement) {
        this.nglFormElement = nglFormElement;
    }
    Object.defineProperty(NglFormElementRequired.prototype, "required", {
        set: function (required) {
            this.nglFormElement.setRequired(required);
        },
        enumerable: true,
        configurable: true
    });
    NglFormElementRequired.decorators = [
        { type: Directive, args: [{
                    selector: 'input[nglFormControl][required], textarea[nglFormControl][required], select[nglFormControl][required]',
                },] },
    ];
    /** @nocollapse */
    NglFormElementRequired.ctorParameters = function () { return [
        { type: NglFormElement, },
    ]; };
    NglFormElementRequired.propDecorators = {
        'required': [{ type: Input },],
    };
    return NglFormElementRequired;
}());
export { NglFormElementRequired };
;
//# sourceMappingURL=required.js.map